import SettingService from '@/services/SettingService';

// state
const localState = {
  autoLoad: {
    loading: false,
    loader: SettingService.getAll,
    emptyMap: {},
  },
  settings: {},
};

// getters
const localGetters = {};

export default {
  state: localState,
  getters: localGetters,
};
